import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@sharedModule/material/material.module';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';

export interface ImageCropperDialogData {
  file: File;
}

/**
 * Popup that lets the user crop the chosen image and finalize it. Closes with
 * the cropped base64 data URL on Finalize, or with `undefined` on Cancel.
 */
@Component({
  selector: 'app-image-cropper-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, ImageCropperComponent],
  templateUrl: './image-cropper-dialog.component.html',
  styleUrl: './image-cropper-dialog.component.scss',
})
export class ImageCropperDialogComponent {
  croppedImage = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImageCropperDialogData,
    private dialogRef: MatDialogRef<ImageCropperDialogComponent, string>
  ) {}

  onImageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64 ?? '';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  finalize(): void {
    this.dialogRef.close(this.croppedImage);
  }
}
